var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.changeTitle, loading: _vm.loading } },
    [
      _c("sc-form", {
        attrs: { form: _vm.productGroup, rules: _vm.rules },
        on: { submit: _vm.save },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-narrow" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Nome", prop: "name" } },
                        [
                          _c("sc-input", {
                            staticClass: "is-narrow",
                            attrs: { placeholder: "Digite o nome do Grupo" },
                            model: {
                              value: fields.name,
                              callback: function($$v) {
                                _vm.$set(fields, "name", $$v)
                              },
                              expression: "fields.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "sc-field",
                        {
                          staticClass: "column",
                          attrs: { label: "Skus", prop: "skus" }
                        },
                        [
                          _c("sc-taginput", {
                            attrs: {
                              placeholder: "Digite os skus",
                              "on-paste-separators": [",", " "],
                              maxtags: 5000
                            },
                            model: {
                              value: fields.skus,
                              callback: function($$v) {
                                _vm.$set(fields, "skus", $$v)
                              },
                              expression: "fields.skus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c(
                  "router-link",
                  {
                    staticClass: "button is-active",
                    attrs: { to: { name: "productGroups" } }
                  },
                  [_vm._v("\n          Voltar\n        ")]
                ),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: {
                    type: "submit",
                    disabled: !isValid,
                    theme: "primary",
                    text: "Salvar"
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76b1879e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76b1879e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/product-groups/pages/product-group-manage/PageProductGroupManage.vue
// module id = null
// module chunks = 